export type ClassValue = string | false | null | undefined;

/**
 * Join classNames, dropping falsy values. Uniwind does not auto-deduplicate,
 * so avoid passing two utilities that set the same property; later-listed
 * variant strings here are authored to not conflict with caller overrides.
 */
export function cn(...parts: ClassValue[]): string {
  return parts.filter(Boolean).join(' ');
}
